import get from 'lodash-es/get';
import has from 'lodash-es/has';
import variables from '../variables';
import smalltalk from '../../vendor/smalltalk';
import {
  startUpgradingIndividualAccount,
  startUpgradingTeamAccount,
} from '../../dashboard/actions/accountActions';
import { addNotification } from '../../editor/actions/notificationsActions';

/**
 * Error handler factory
 *
 * @param error
 * @param config
 * @return {function(*=)}
 */
const handleError = (error, config = {}) => dispatch => {
  if (!error) {
    return;
  }

  if (error.log !== false) {
    // If error is not a custom error, it won't have any log/report/alert/reload params,
    // so we must take into account those values can be undefined.
    console.error(error);
  }

  if (error.report !== false) {
    if (window.Raven) {
      window.Raven.captureException(error, error.message);
    } else {
      console.info(
        'Should report error but Raven is not active',
        error,
        error.message,
      );
    }
  }

  let redirect;
  if (error.name === 'UpgradeError') {
    redirect = () => {
      if (error.isTeam) {
        dispatch(startUpgradingTeamAccount());
      } else {
        dispatch(startUpgradingIndividualAccount());
      }
    };
  } else if (error.reload) {
    redirect = () => {
      // Don't trigger any unload event listeners
      window.onbeforeunload = null;
      window.location.reload(true);
    };
  }

  if (error.notify !== false) {
    dispatch(addNotification(error.message, error.notificationType));
  }

  if (error.alert !== false || error.reload) {
    if (has(config, 'onAlert')) {
      config.onAlert();
    }
    if (error.alertMessage) {
      smalltalk.alert(error.title, error.alertMessage).then(() => {
        if (redirect) {
          redirect();
        }
      });
    } else {
      smalltalk.alert(
        'Oops',
        get(
          config,
          'defaultAlertMessage',
          `${variables.errors.default}<br><code>${error}</code>`,
        ),
      );
    }
  }
};

export default handleError;
